export default "__VITE_ASSET__D1f_Hlxl__"